import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportProposalPageRoutingModule } from './report-proposal-routing.module';

import { ReportProposalPage } from './report-proposal.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportProposalPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [ReportProposalPage]
})
export class ReportProposalPageModule {}
